import {CustomerAddedTimelineEntry} from './CustomerAddedTimelineEntry';
import {CustomerDeletedTimelineEntry} from './CustomerDeletedTimelineEntry';
import {CustomerUpdatedTimelineEntry} from './CustomerUpdatedTimelineEntry';
import {CustomNoteTimelineEntry} from './CustomNoteTimelineEntry';
import {DocumentDownloadedTimelineEntry} from './DocumentDownloadedTimelineEntry';
import {DocumentUploadedTimelineEntry} from './DocumentUploadedTimelineEntry';
import {ExtraWorkEntryAddedTimelineEntry} from './ExtraWorkEntryAddedTimelineEntry';
import {ExtraWorkEntryDeletedTimelineEntry} from './ExtraWorkEntryDeletedTimelineEntry';
import {ExtraWorkEntryUpdatedTimelineEntry} from './ExtraWorkEntryUpdatedTimelineEntry';

export const timelineEntryComponents = {
    CustomerAdded: CustomerAddedTimelineEntry,
    CustomerDeleted: CustomerDeletedTimelineEntry,
    CustomerUpdated: CustomerUpdatedTimelineEntry,
    CustomNote: CustomNoteTimelineEntry,
    DocumentDownloaded: DocumentDownloadedTimelineEntry,
    DocumentUploaded: DocumentUploadedTimelineEntry,
    ExtraWorkEntryAdded: ExtraWorkEntryAddedTimelineEntry,
    ExtraWorkEntryDeleted: ExtraWorkEntryDeletedTimelineEntry,
    ExtraWorkEntryUpdated: ExtraWorkEntryUpdatedTimelineEntry,
};
